
import EmailLayout from './EmailLayout';

const EmailApp = () => {
  return <EmailLayout />;
};

export default EmailApp;
